import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

function FAQ() {
  const [open, setOpen] = useState(null);

  const data = [
    {
      q: "How long does a typical project take?",
      a: "Usually 2 to 6 weeks depending on scope, complexity, and specific requirements."
    },
    {
      q: "What technologies do you specialize in?",
      a: "We specialize in React, Node.js, Spring Boot, Artificial Intelligence, AWS Cloud infrastructure, and DevOps pipelines."
    },
    {
      q: "Do you offer post-launch support and maintenance?",
      a: "Yes, we provide ongoing maintenance, scaling support, and feature updates."
    }
  ];

  return (
    <section className="faq">
      <motion.div 
        className="section-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <span className="section-tag">Questions</span>
        <h2 className="section-title">Frequently Asked Questions</h2>
      </motion.div>

      <div className="faq-list">
        {data.map((item, index) => (
          <motion.div 
            layout
            key={index} 
            className={`faq-item ${open === index ? 'active' : ''}`}
            onClick={() => setOpen(open === index ? null : index)}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <motion.h3 layout>
              {item.q}
              {open === index ? <FaChevronUp size={14} color="var(--accent-teal)" /> : <FaChevronDown size={14} />}
            </motion.h3>
            <AnimatePresence>
              {open === index && (
                <motion.div 
                  className="faq-answer-anim"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  style={{ overflow: 'hidden' }}
                >
                  <p style={{ padding: "0 20px 20px", color: "var(--text-secondary)", margin: 0 }}>{item.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;